import { AvailableSettings } from '../definitions';

// TODO: remove this when the chart conception feature is reliable
export const additionalSettingsOnConceptionDisabled: AvailableSettings[] = [
    'reverseGroupBy',
];
